import styled from 'styled-components'

export const StyledModeDescription = styled.p`
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textStrong};
  margin-bottom: 12px !important;
`

export const StyledWithdrawalOptions = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;

  ${({ theme }) => theme.media.sm`
    flex-direction: column;
  `}
`

export const StyledWithdrawalOption = styled.div<{ selected?: boolean }>`
  flex: 1;
  padding: 16px;
  border: 1.5px solid
    ${({ theme, selected }) =>
      selected ? theme.colors.primary : theme.colors.borderSubtle};
  border-radius: 12px;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`

export const StyledOptionTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  color: #000;
  margin-bottom: 12px;

  img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
`

export const StyledOptionTime = styled.div`
  align-self: flex-end;
  height: 24px;
  padding: 0 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  text-align: right;
  color: ${({ theme }) => theme.colors.textStrong};
  background: #f5f7fb;
`

export const StyledWithdrawalStep = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
`

export const StyledStepNumber = styled.div`
  width: 20px;
  height: 20px;
  background: #000;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
`

export const StyledStepTitle = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #000;
`

export const StyledClaimSection = styled.div`
  display: flex;
  flex-direction: column;
`
